import { render, staticRenderFns } from "./cert-center-work-create.vue?vue&type=template&id=21b25632&"
import script from "./cert-center-work-create.vue?vue&type=script&lang=js&"
export * from "./cert-center-work-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports